<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="maxWidth"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="onSave" >
					<v-icon>mdi-content-save</v-icon>
				</v-btn>

				<!-- <v-divider vertical></v-divider> -->

				<!-- <v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn> -->
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-form ref="form">
					<v-expansion-panels v-model="panel" multiple>
						<v-expansion-panel>
							<!-- <v-expansion-panel-header>Основна інформація</v-expansion-panel-header> -->
							<v-expansion-panel-header>
								<v-toolbar flat>
									<v-app-bar-nav-icon>
										<v-icon>mdi-car</v-icon>
									</v-app-bar-nav-icon>
									<v-toolbar-title>Основна інформація</v-toolbar-title>
									<v-spacer></v-spacer>
								</v-toolbar>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12" md="9">
										<v-text-field
											:label="$vuetify.lang.t('$vuetify.name') | capitalize"
											v-model="item.name"
											clearable
											outlined
											dense
											hide-details="auto"
											:rules="[rules.required]"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="3">
										<v-text-field
											:label="$vuetify.lang.t('$vuetify.code') | capitalize"
											v-model="item.code"
											clearable
											outlined
											dense
											hide-details="auto"
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<z-type
											v-model="item.type"
											label="Тип"
											:defaultIndex="0"
											outlined
											dense
											hide-details="auto"
										></z-type>
									</v-col>
									<v-col cols="12">
										<v-textarea
											v-model="item.description"
											:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
											hint=""
											rows="2"
											outlined
											dense
											hide-details="auto"
										></v-textarea>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel>
							<v-expansion-panel-header>
								<v-toolbar flat>
									<v-app-bar-nav-icon>
										<v-icon>mdi-car</v-icon>
									</v-app-bar-nav-icon>
									<v-toolbar-title>Транспортні засоби</v-toolbar-title>
									<v-spacer></v-spacer>


									<z-estimate>
										<template v-slot:activator="props">
											<v-btn v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}" class="mx-1">
												<v-icon left>mdi-tag-text</v-icon>
												Оцінка
											</v-btn>
										</template>
									</z-estimate>

									<!-- <v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<v-btn v-bind="attrs" v-on="on" class="mx-1">
												<v-icon left>mdi-tag-text</v-icon>
												Оцінка
												<v-icon right>mdi-menu-down</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item v-for="(item, index) in estimateTypes" @click="onEstimate(item)">
												<v-list-item-icon>
													<v-icon>{{ item.icon }}</v-icon>
												</v-list-item-icon>
												<v-list-item-content>
													<v-list-item-title>{{ item.name }}</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu> -->

									<v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<v-btn v-bind="attrs" v-on="on" class="mx-1">
												<v-icon left>mdi-car-search</v-icon>
												Ідентифікація
												<v-icon right>mdi-menu-down</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item v-for="(item, index) in identificationTypes" @click="onIdentification(item)">
												<v-list-item-icon>
													<v-icon>{{ item.icon }}</v-icon>
												</v-list-item-icon>
												<v-list-item-content>
													<v-list-item-title>{{ item.name }}</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>

									<!-- <v-divider vertical></v-divider> -->

									<v-btn @click="onExport" class="mx-1" v-if="item.objects.length">
										<v-icon left>mdi-export</v-icon>
										Експорт
									</v-btn>

									<z-import-excel 
										accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
										:headers="ie.headers"
										@ok="addVehicles"
									>
										<template v-slot:activator="props">
											<v-btn v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}" class="mx-1">
												<v-icon left>mdi-import</v-icon>
												Імпорт
											</v-btn>
										</template>
									</z-import-excel>

									<!-- <v-divider vertical inset></v-divider> -->

									<!-- <v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon v-bind="attrs" v-on="on" @click="onDeleteVehicleSelected" :disabled="!select.vehicles.length">
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</template>
										<span>Видалити</span>
									</v-tooltip> -->

									<!-- <z-vehicle @add="addVehicle"> -->
									<z-vehicle @ok="addObject">
										<template v-slot:activator="props">
											<v-btn v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}" class="mx-1">
												<v-icon left>mdi-plus</v-icon>
												Додати
											</v-btn>
										</template>
									</z-vehicle>
								</v-toolbar>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<!-- <v-data-table
									v-model="select.vehicles"
									:items="vehicles"
									:headers="header.vehicles"
									hide-default-footer
									:items-per-page="-1"
								> -->
								<v-data-table
									v-model="select.vehicles"
									:items="item.objects"
									:headers="header.objects"
									hide-default-footer
									:items-per-page="-1"
								>
									<template v-slot:[`item.avgPriceUAH`]="{ item }">
										<span>{{ item.avgPriceUAH | toCurrencyUAH }}</span>
									</template>
									<template v-slot:[`item.avgPriceUSD`]="{ item }">
										<span>{{ item.avgPriceUSD | toCurrencyUSD }}</span>
									</template>
									<template v-slot:item.actions="{ item, index }">
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-icon class="mx-3" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
											</template>
											<v-list>
												<!-- <z-vehicle v-model="item" @edit="editVehicle(item, $event)"> -->
												<z-vehicle v-model="item.vehicle" @ok="editObject(item, $event)">
													<template v-slot:activator="props">
														<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
															<v-list-item-icon>
																<v-icon>mdi-pencil</v-icon>
															</v-list-item-icon>
															<v-list-item-content>
																<v-list-item-title>Редагувати</v-list-item-title>
															</v-list-item-content>
														</v-list-item>
													</template>
												</z-vehicle>

												<!-- <z-confirm-delete @ok="onDeleteVehicle(item)"> -->
												<z-confirm-delete @ok="removeObject(item)">
													<template v-slot:activator="props">
														<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
															<v-list-item-icon>
																<v-icon>mdi-delete</v-icon>
															</v-list-item-icon>
															<v-list-item-content>
																<v-list-item-title>Видалити</v-list-item-title>
															</v-list-item-content>
														</v-list-item>
													</template>
												</z-confirm-delete>
												
												<v-divider></v-divider>

												<v-subheader>Ідентифікація</v-subheader>
												<v-list-item v-for="(type, index) in identificationTypes" @click="onIdentificationItem(type, item)">
													<v-list-item-icon>
														<v-icon>{{ type.icon }}</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>{{ type.name }}</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
												
												<!-- <v-list-item @click="onIdentification(item, 'number')">
													<v-list-item-icon>
														<v-icon>mdi-alpha-n-box</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>За номером</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
												<v-list-item @click="onIdentification(item, 'vin')">
													<v-list-item-icon>
														<v-icon>mdi-alpha-v-box</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>За VIN-кодом</v-list-item-title>
													</v-list-item-content>
												</v-list-item> -->

												<v-divider></v-divider>

												<v-subheader>Оцінка</v-subheader>
												<v-list-item v-for="(type, index) in estimateTypes" @click="onEstimateItem(type, item)">
													<v-list-item-icon>
														<v-icon>{{ type.icon }}</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>{{ type.name }}</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
											</v-list>
										</v-menu>
									</template>
									<template v-slot:body.append>
										<tr>
											<td colspan="9"><strong>Всього</strong></td>
											<td class="text-right" v-if="!isNaN(calculateTotalUAH())">{{ calculateTotalUAH() | toCurrencyUAH }}</td>
											<td class="text-right" v-if="!isNaN(calculateTotalUSD())">{{ calculateTotalUSD() | toCurrencyUSD }}</td>
										</tr>
									</template>
									<template v-slot:no-data>
										<i>Транспортні засоби відсутні. </i>
									</template>
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<!-- <v-btn color="success" dark @click.native="onSave" :disabled="loading">Зберегти</v-btn> -->
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<z-snackbar-alert v-model="snackbar.noVehicles" type="error" title="Увага!" text="<b>Транспортні засоби в переліку відсутні!</b><br>Додайте хоча б один транспортний засіб до переліку" :timeout="5000"></z-snackbar-alert>
		<z-snackbar-accept v-model="snackbar.identification.onlyForNumbers" type="warning" title="Увага!" text="Ідентифікація буде проведена тільки для тих транстпортних засобів, для яких зазначено реєстраційний номер. Продовжити?" :timeout="5000"></z-snackbar-accept>
		<z-snackbar-accept v-model="snackbar.identification.onlyForVins" type="warning" title="Увага!" text="Ідентифікація буде проведена тільки для тих транстпортних засобів, для яких зазначено  vin-код. Продовжити?" :timeout="5000"></z-snackbar-accept>
		<z-snackbar-alert v-model="snackbar.identification.noVehiclesNumber" type="error" title="Увага!" text="<b>Ідентифікація неможлива!</b><br>Не зазначено реєстраційний номер транспортного засобу!" :timeout="5000"></z-snackbar-alert>
		<z-snackbar-alert v-model="snackbar.identification.noVehiclesVin" type="error" title="Увага!" text="<b>Ідентифікація неможлива!</b><br>Не зазначено vin-код транспортного засобу!" :timeout="3000"></z-snackbar-alert>
		
		<z-snackbar-accept v-model="snackbar.estimate.onlyForCorrect" type="warning" title="Увага!" text="Оцінка буде проведена тільки для тих транстпортних засобів, для яких зазначено базові параметри (марка, модель, рік випуску). Продовжити?" :timeout="5000"></z-snackbar-accept>
		<z-snackbar-alert v-model="snackbar.estimate.noCorrect" type="error" title="Увага!" text="<b>Оцінка неможлива!</b><br>Не зазначені базові параметри: марка, модель, рік випуску." :timeout="5000"></z-snackbar-alert>
		
		
		<!-- alert - Транспортні засоби в переліку відсутні.

		warning - Ідентифікація буде проведена тільки для тих транстпортних засобів, для яких зазначено реєстраційний номер. Продовжити? 
		warning - Ідентифікація буде проведена тільки для тих транстпортних засобів, для яких зазначено vin-код. Продовжити?
		Увага! Ідентифікація неможлива! Не зазначено реєстраційний номер транспортного засобу!
		Увага! Ідентифікація неможлива! Не зазначено vin-код транспортного засобу!

		Увага! Оцінка буде проведена тільки для тих транстпортних засобів, для яких зазначено базові параметри (марка, модель, рік випуску). Продовжити? 
		Увага! Проведення оцінки неможливе! Не зазначені базові параметри: марка, модель, рік випуску.
		
 -->
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-file-input class="d-none" ref="fileinput" v-model="file" @change="changeFile"></v-file-input>

		<z-pdf-estimate ref="pdfEstimate" :item="itemPdf"></z-pdf-estimate>

		<!-- <z-dialog-estimate ref="dialogEstimate" :park="item" @ok="addEstimate" tooltip="create">
			<template v-slot:activator="props"></template>
		</z-dialog-estimate> -->

	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zType from '@/views/components/controls/select/FleetType'
import zVehicle from '@/views/dialogs/details/Vehicle'
import zEstimate from '@/views/dialogs/details/FleetEstimate'

import zSnackbarAlert from '@/views/components/snackbar/Alert'
import zSnackbarAccept from '@/views/components/snackbar/Accept'

import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete2'
import zImportExcel from '@/views/components/dialogs/Import'
import zPdfEstimate from '@/views/pdf/VehicleParkEstimate'

import * as XLSX from 'xlsx'; //https://www.npmjs.com/package/xlsx

export default {
	name: 'DialogDetailFleet',
	mixins: [mixin],
	components: {
		zType
		,zVehicle
		,zEstimate
		,zConfirmDelete
		,zImportExcel
		,zPdfEstimate

		,zSnackbarAlert, zSnackbarAccept
	},
	data: () => ({
		/* title: 'Парк',
		icon: 'mdi-car-2-plus', */
		file: null,
		//tab: null,
		//tabs: ['Головна', 'Транспортні засоби', 'Оцінки'],
		panel: [0,1],

		identificationTypes: [
			{ id: 1, code: 'number', name: 'За номером', icon: 'mdi-alpha-n-box' },
			{ id: 2, code: 'vin', name: 'За VIN-кодом', icon: 'mdi-alpha-v-box' },
		],

		header: {
			vehicles: [
				{ text: 'ID', value: 'id', sortable: true, width: '50'},
				{ text: 'Номер', value: 'number', sortable: true},
				{ text: 'VIN', value: 'vin', sortable: true},
				{ text: 'Марка', value: 'brand.name', sortable: true},
				{ text: 'Модель', value: 'model.name', sortable: true},
				{ text: 'Рік випуску', value: 'yearProd', sortable: true, align: 'center'},
				//{ text: 'Тип приводу', value: 'driver.name', sortable: true},
				{ text: "Об'єм двигуна, л", value: 'engineVolume', sortable: true},
				{ text: 'Тип палива', value: 'fuel.name', sortable: true},
				//{ text: 'Коробка передач', value: 'gearbox.name', sortable: true},
				{ text: 'Колір', value: 'color.name', sortable: true},
				//{ text: 'Показник одометра', value: 'odometer', sortable: true},
				{ text: 'Середня ціна, UAH', value: 'avgPriceUAH', sortable: true, align: 'end'},
				{ text: 'Середня ціна, USD', value: 'avgPriceUSD', sortable: true, align: 'end'},
				//{ text: '', value: 'actions', sortable: false, width: '10%', align: 'end' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
			objects: [
				{ text: 'ID', value: 'id', sortable: true, width: '50'},
				{ text: 'Номер', value: 'vehicle.number', sortable: true},
				{ text: 'VIN', value: 'vehicle.vin', sortable: true},
				{ text: 'Марка', value: 'vehicle.brand.name', sortable: true},
				{ text: 'Модель', value: 'vehicle.model.name', sortable: true},
				{ text: 'Рік випуску', value: 'vehicle.yearProd', sortable: true, align: 'center'},
				//{ text: 'Тип приводу', value: 'vehicle.driver.name', sortable: true},
				{ text: "Об'єм двигуна, л", value: 'vehicle.engineVolume', sortable: true},
				{ text: 'Тип палива', value: 'vehicle.fuel.name', sortable: true},
				//{ text: 'Коробка передач', value: 'vehicle.gearbox.name', sortable: true},
				{ text: 'Колір', value: 'vehicle.color.name', sortable: true},
				//{ text: 'Показник одометра', value: 'vehicle.odometer', sortable: true},
				{ text: 'Середня ціна, UAH', value: 'avgPriceUAH', sortable: true, align: 'end'},
				{ text: 'Середня ціна, USD', value: 'avgPriceUSD', sortable: true, align: 'end'},
				//{ text: '', value: 'actions', sortable: false, width: '10%', align: 'end' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		},

		ie: {
			headers: [
				//{ text: 'ID', value: 'id', column: { text: 'A', value: 1 }},
				{ text: 'Номер', value: 'number', column: { text: 'A', value: 1 }},
				{ text: 'VIN', value: 'vin', column: { text: 'B', value: 2 }},
				{ text: 'Марка', value: 'brand.name', column: { text: 'C', value: 3 }},
				{ text: 'Модель', value: 'model.name', column: { text: 'D', value: 4 }},
				{ text: 'Рік випуску', value: 'yearProd', column: { text: 'E', value: 5 }, type: 'int'},
				{ text: 'Тип приводу', value: 'driver.name', column: { text: 'F', value: 6 }},
				{ text: "Об'єм двигуна", value: 'engineVolume', column: { text: 'G', value: 7 }, type: 'float',
					getValue: (value) => { 
						return value > 1000 ? value / 1000 : value
					}
				},
				{ text: 'Тип палива', value: 'fuel.name', column: { text: 'H', value: 8 }},
				{ text: 'Коробка передач', value: 'gearbox.name', column: { text: 'I', value: 9 }},
				{ text: 'Колір', value: 'color.name', column: { text: 'J', value: 10 }},
				{ text: 'Показник одометра', value: 'odometer', column: { text: 'K', value: 11 }},
			],
		},

		item: {
			objects: []
		},

		select: {
			vehicles: [],
			//estimates: [],
		},

		itemPdf: {},

		/* alert: {
			identification: { 
				noVehicles: false,
				onlyForNumbers: false,
			},
		}, */

		snackbar: {
			noVehicles: false,
			identification: { 
				onlyForNumbers: false,
				onlyForVins: false,
				noVehiclesNumber: false,
				noVehiclesVin: false,
			},
			estimate: {
				onlyForCorrect: false,
				noCorrect: false,
			},

			visible: false,
			text: null,
			timeout: 2000,
			color: "success"
		},
		loadings: {
			/* category: false,
			brand: false,
			model: false,
			year: false, */
			type: false,
		},

		//types: [],


	}),

	props: {
		title: 				{ type: String, default: 'Парк' },
		icon: 				{ type: String, default: 'mdi-car-2-plus' },
		maxWidth: 			{ type: Number, default: 800 },

		/* category: 			{ type: Object, default: null },
		brand: 				{ type: Object, default: null },
		model: 				{ type: Object, default: null },
		modelYear: 			{ type: Number, default: null },
		type: 				{ type: Object, default: null }, */
	},

	computed: {
		//...mapGetters('Fleet', [ 'item' ]),
		//...mapGetters('FleetType', { types: 'items' }),
		...mapGetters('FleetObjectEstimateType', { estimateTypes: 'items' }),

		id() {
			return this.item?.id ? this.item.id : null
		},

		/* objects() {
			return this.item?.objects ? this.item.objects : this.$set(this.item, 'objects', [])
		}, */

		/* vehicles() {
			return this.item?.vehicles ? this.item.vehicles : this.$set(this.item, 'vehicles', [])
		}, */

		notAllNumbers() {
			return this.item.objects.some(item => !item.number);
		},

		notAllProperties() {
			return this.item.objects.some(item => !item?.brand?.id && !item?.model?.id );
		},

		/* table_vehicles() {
			return this.vehicles.map((item, index) => ({
				...item,
				uniqueIndex: index,
			}));
		}, */

		/* estimates() {
			return this.item?.estimates ? this.item.estimates : this.$set(this.item, 'estimates', [])
		}, */
	},

	created () {
		//console.log(this.$options.name, 'created')

		this.fullscreen = true;

		//this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		//this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0]))

		if(!this.estimateTypes.length) this.loadFleetObjectEstimateType();
	},

	methods: {
		...mapActions('FleetObjectEstimateType', { loadFleetObjectEstimateType: 'load' }),

		//-------------------------------------------------------------------------

		find(id) {
			return axios.get(`/fleet/${id}`).then(response => {
				//console.log(that.$options.name, 'find','response.data', response.data)
				this.item = response.data
			}, error => {
				console.log(error)
			})
		},

		create (item) {
			//console.log(this.$options.name, 'create','item', item)

			return axios.post('/fleet', item).then(response => {
				//console.log('index', 'create','response.data', response.data)
				this.item = response.data
				this.$emit('create', this.item)
			}, error => {
				console.log(error)
			})
		},

		update (id, item) {
			//console.log('update','id', id, 'item', item)

			return axios.put(`/fleet/${id}`, item).then(response => {
				//console.log(this.$options.name, 'update','response.data', response.data)
				this.item = response.data
				this.$emit('update', this.item)
			}, error => {
				console.log(error)
			})
		},
		
		save() {
			return this.id ? this.update(this.id, this.item) : this.create(this.item);
		},

		//--------------------------------------------------------------------------

		onOpen () {
			//console.log(this.$options.name, 'onOpen', 'selected', this.selected)
			
			if(this.selected?.id) {
				this.loading = true
				this.find(this.selected.id).finally(() => (this.loading = false));
			}
		},

		onSave() {
			//console.log(this.$options.name, 'item', this.item);

			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(() => {
					//this.dialog = false
					/* this.snackbar.text = 'Дані збережено'
					this.snackbar.visible = true
					this.snackbar.color = 'success' */
				}).finally(() => {
					this.loading = false
				});
			} else {
				/* this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error' */
			}
		},

		onOK() {
			//console.log(this.$options.name, 'item', this.item);

			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(()=>{
					this.dialog = false
				}).finally(() => {
					this.loading = false
				});
			}
		},

		addObject(item) {
			//console.log(this.$options.name, 'item', item)
			this.item.objects.push({
				vehicle: item
			});
			//this.item.objects.push(item);
		},

		editObject(selected, item) {
			//console.log(this.$options.name, 'selected', selected)
			//console.log(this.$options.name, 'item', item)

			const index = this.item.objects.indexOf(selected)
			this.item.objects.splice(index, 1, {
				vehicle: item
			})
		},

		removeObject(item) {
			//console.log(this.$options.name, 'removeVehicle', 'data', data)
			const index = this.item.objects.indexOf(item)
			this.item.objects.splice(index, 1);
		},


		addVehicle(item) {
			//console.log(this.$options.name, 'item', item)

			this.vehicles.push(item);

			//console.log(this.$options.name, 'vehicles', this.vehicles)
		},

		addVehicles(items) {
			//console.log(this.$options.name, 'items', items)
			items.forEach((item) => {
				
				if(item?.engineVolume > 1000) {
					item.engineVolume = item.engineVolume / 1000
				}

				this.addVehicle(item);
			})
		},

		editVehicle(selected, item) {
			//console.log(this.$options.name, 'selected', selected)
			//console.log(this.$options.name, 'item', item)

			const index = this.vehicles.indexOf(selected)
			this.vehicles.splice(index, 1, item)
		},

		removeVehicle(data) {
			//console.log(this.$options.name, 'removeVehicle', 'data', data)
			const index = this.vehicles.indexOf(data)

			//const index = this.table_vehicles.indexOf(data)
			//const index = data.index

			//console.log(this.$options.name, 'removeVehicle', 'index', index)

			this.vehicles.splice(index, 1);
		},

		deleteVehicle(item) {
			let that = this
			return axios.delete(`/vehicle/request/${item.id}`).then(response => {
				//console.log(this.$options.name, 'deleteVehicle','response.data', response.data)
				that.removeVehicle(item)
			}, error => {
				//if()
				console.log(error)
			})
		},

		onDeleteVehicle(item) {
			if(item?.id) {
				this.deleteVehicle(item)
			} else {
				this.removeVehicle(item)
			}
		},

		onDeleteVehicleSelected() {
			this.select.vehicles.forEach((item) => {
				if(item?.id) {
					this.deleteVehicle(item)
				} else {
					this.removeVehicle(item)
				}
			})

			this.select.vehicles = []
		},

		//-- Estimate -----------------------------------------------------------------

		onEstimate(type) {
			//console.log(this.$options.name, 'onEstimate', 'type', type)

			if(!this.item.objects.length) {
				this.snackbar.noVehicles = true; 
				return
			}

			if(this.notAllProperties) {
				this.snackbar.estimate.onlyForCorrect = true; 
			}

			//console.log(this.$options.name, 'onEstimate', item)
			/* if(this.$refs.form.validate()) {
				this.loading = true
				const p = this.save()
				p.then(()=>{
					this.$refs.dialogEstimate.dialog = true;
				}).finally(() => {
					this.loading = false
				});
			} else {
				this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error'
			} */
		},

		onEstimateItem(type, item) {
			console.log(this.$options.name, 'onEstimateItem', 'type', type)
			console.log(this.$options.name, 'onEstimateItem', 'item', item)

			/* if(this.$refs.form.validate()) {
				this.loading = true
				const p = this.save()
				p.then(()=>{
					this.$refs.dialogEstimate.dialog = true;
				}).finally(() => {
					this.loading = false
				});
			} else {
				this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error'
			} */
		},

		//-- Identification -----------------------------------------------------------------

		/**
		 * Ідентифікація ТЗ за номером або vin-кодом
		 * 
		 * @param item 
		 */
		identification(type, item) {
			//const vinnumber = item?.vin ? item.vin : item?.number;
			/* const vinnumber = item[field];
			if(!vinnumber) return; */

			//const url = `/fleet/object/${item.id}/define/${type.code}/${type.code=='vin' ? item?.vin : item?.number }`;
			const url = `/fleet/object/${item.id}/identification`;

			return axios.post(url).then(response => {
				console.log(this.$options.name, 'identification','response.data', response.data)
				/* if(response.data?.favorit) {
					if(response.data?.favorit?.number) item.number = response.data.favorit.number;
					if(response.data?.favorit?.vin) item.vin = response.data.favorit.vin;
					if(response.data?.favorit?.brand) item.brand = response.data.favorit.brand;
					if(response.data?.favorit?.model) item.model = response.data.favorit.model;
					if(response.data?.favorit?.yearProd) item.yearProd = response.data.favorit.yearProd;
					if(response.data?.favorit?.color) item.color = response.data.favorit.color;
					if(response.data?.favorit?.fuel) item.fuel = response.data.favorit.fuel;
					if(response.data?.favorit?.engineVolume) item.engineVolume = response.data.favorit.engineVolume;
				} */

				const index = this.item.objects.indexOf(item)
				this.item.objects.splice(index, 1, response.data)

			}, error => { console.log(error) });
			//.finally(() => { this.loading = false });
		},

		onIdentification(type) {
			//console.log(this.$options.name, 'onIdentification', 'type', type)

			if(!this.item.objects.length) {
				this.snackbar.noVehicles = true; 
				return
			}

			if(this.notAllNumbers) {
				this.snackbar.identification.onlyForNumbers = true; 
			}
			
			

			/* this.loading = true;
			this.vehicles.forEach((item, index) => this.identification(type, item)).finally(() => { this.loading = false });
 */
			/* this.identification(item, field)

			this.vehicles.forEach((item, index) => this.identification(item, field))
			this.vehicles.forEach((item, index) => {
				const vinnumber = item?.vin ? item.vin : item?.number;
				if(vinnumber) {
					this.identification(item)
				} else {
					console.log(this.$options.name, 'onIdentification', index, 'Ні номер, ні vin не визначено')
				}
			}) */
		},

		onIdentificationItem(type, item) {
			console.log(this.$options.name, 'onIdentificationItem', 'type', type)
			console.log(this.$options.name, 'onIdentificationItem', 'item', item)

			this.loading = true;
			this.identification(type, item).finally(() => { this.loading = false });

			//const type_
			
			/* if(this.$refs.form.validate()) {
				this.loading = true
				const p = this.save()
				p.then(()=>{
					this.$refs.dialogEstimate.dialog = true;
				}).finally(() => {
					this.loading = false
				});
			} else {
				this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error'
			} */
		},

		/* onIdentificationItem
		onIdentification(item, field) {
			if(item) {
				this.identification(item, field)
			} else {
				this.vehicles.forEach((item, index) => this.identification(item, field))
			}
		}, */

		//-----------------------------------------------------------------

		onImport() {
			this.file = null

			this.$refs.fileinput.$refs.input.click()
		},

		changeFile(files) {
			if(Array.isArray(files)) {
				files.forEach((file) => this.processFile(file))
			} else {
				this.processFile(files)
			}
		},

		/**
		 * Обробка файлу
		 * @param file 
		 */
		processFile(file) {
			if (file) {
				const reader = new FileReader();

				reader.onload = (e) => {
					//console.log(this.$options.name, 'processFile', 'XLSX', XLSX)

					let result = {}

					const bstr = e.target.result;
					const workbook = XLSX.read(bstr, { type: 'binary' });

					workbook.SheetNames.forEach((sheetName) => {
						//console.log(this.$options.name, 'processFile', 'sheetName', sheetName)
						//console.log(this.$options.name, 'processFile', 'sheet', sheet)

						const worksheet 	= workbook.Sheets[sheetName];
						const data_array 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

						//console.log(this.$options.name, 'processFile', 'data_array', data_array)
						data_array.forEach((data) => {
							let 
								brandName = data[1],
								modelName = data[2],
								yearProd = parseInt(data[3]),
								engineVolume = parseFloat(data[4])
							;


							if(!isNaN(yearProd) && !isNaN(engineVolume)) {
								this.item.objects.push({
									number: null,
									vin: null,
									brand: { name: brandName},
									model: { name: modelName},
									yearProd: yearProd,
									engineVolume: engineVolume > 1000 ? engineVolume / 1000 : engineVolume,
								})
							}
						})
					})

					//const ws = sheetName ? workbook.Sheets[sheetName] : workbook.Sheets[wb.SheetNames[s]]

					//const data_array 	= XLSX.utils.sheet_to_json(ws, { header: 1 });

					
					// Перетворення в об'єкт для відповіді
					/* if(this.workbook.hasOwnProperty('sheets')) {
						this.workbook.sheets.forEach((sheet, s) => {
							let type = sheet?.type ? sheet.type : 'Object'
								,sheetName = sheet?.name
							;

							//console.log(this.$options.name, 'changeImport', 'type', type)
							//console.log(this.$options.name, 'changeImport', 'sheetName', sheetName)

							let element = null
							switch(type){
								case 'Array': 	element = []; break;
								case 'Object': 	element = {}; break;
							}

							if(sheet?.element) {
								result[sheet.element] = element
							} else {
								element = result
							}

							const ws = sheetName ? wb.Sheets[sheetName] : wb.Sheets[wb.SheetNames[s]]

							const data_array 	= XLSX.utils.sheet_to_json(ws, { header: 1 });
							//const data_json 	= XLSX.utils.sheet_to_row_object_array(ws)

							//console.log(this.$options.name, 'changeImport', 'data_array', data_array)

							if(Array.isArray(element)) {
								data_array.forEach((row, r) => {
									if(r > 0) {
										let obj = {}
										sheet.headers.forEach((header, h) => {
											this.setValue(obj, header.value, row[h])
										})

										element.push(obj)
									}
								})
							} else {
								data_array.forEach((row, r) => {
									if(r > 0) {
										sheet.headers.forEach((header, h) => {
											this.setValue(element, header.value, row[h])
										})
									}
								})
							}
						})
					} */

					//console.log(this.$options.name, 'changeImport', 'result', result)

					//this.$emit('import', result)
				}

				//reader.readAsBinaryString(this.file);
				reader.readAsArrayBuffer(this.file);
			}
		},

		onExport() {
			//console.log(this.$options.name, 'onExport', 'vehicles', this.vehicles)

			const filename = 'park.xlsx';

			var opts = { bookType:"xlsx", bookSST:false, type:"array" };

			const workbook = XLSX.utils.book_new();

			const jsa = this.item.objects.map(item => {
				return {
					'Номер': item?.number,
					'VIN': item?.vin,
					'Марка': item?.brand?.name,
					'Модель': item?.model?.name,
					'Рік випуску': item?.yearProd,
					'Тип приводу': item?.driver?.name,
					"Об'єм двигуна, л": item?.engineVolume,
					'Тип палива': item?.fuel?.name,
					'Коробка передач': item?.gearbox?.name,
					'Колір': item?.color?.name,
					'Показник одометра': item?.odometer,
				};
			});

			const worksheet = XLSX.utils.json_to_sheet(jsa);

			XLSX.utils.book_append_sheet(workbook, worksheet, 'Vehicles');
			XLSX.writeFileXLSX(workbook, filename);
		},

		onPDFEstimate(item) {
			//console.log(this.$options.name, 'onPDFEstimate', 'item', item)
			let that = this
			this.loading = true
			axios.get(`/vehicle/park/estimate/${item.id}`).then(response => {
				//console.log(this.$options.name, 'onPDFEstimate','response.data', response.data)
				that.itemPdf = response.data;
				that.$refs.pdfEstimate.generate();
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		onExcelEstimate(item) {
			//console.log(this.$options.name, 'onExcelEstimate', 'item', item)

			let that = this
			this.loading = true
			axios.get(`/vehicle/park/estimate/${item.id}`).then(response => {
				//console.log(this.$options.name, 'onExcelEstimate','response.data', response.data)

				let data = response.data;

				const filename = `Оцінка парку ${data.id}.xlsx`;

				var opts = { bookType:"xlsx", bookSST:false, type:"array" };

				const workbook = XLSX.utils.book_new();

				let main = {}
				if(data?.id) main['Ідентифікатор'] = data.id
				if(data?.code) main['Код'] = data.code
				if(data?.name) main['Назва'] = data.name
				if(data?.date) main['Дата'] = data.date
				if(data?.type?.name) main['Тип'] = data.type.name
				if(data?.user?.name) main['Користувач'] = data.user.name
				//if(data?.minPriceUAH) main['Вартість (мінімальна), UAH'] = data.minPriceUAH
				//if(data?.minPriceUSD) main['Вартість (мінімальна), USD'] = data.minPriceUSD
				if(data?.avgPriceUAH) main['Середня ціна, UAH'] = data.avgPriceUAH
				if(data?.avgPriceUSD) main['Середня ціна, USD'] = data.avgPriceUSD
				//if(data?.maxPriceUAH) main['Вартість (максимальна), UAH'] = data.maxPriceUAH
				//if(data?.maxPriceUSD) main['Вартість (максимальна), USD'] = data.maxPriceUSD

				//console.log(this.$options.name, 'onExcelEstimate', 'main', main)

				const worksheet = XLSX.utils.json_to_sheet([main]);

				const jsa = data.estimates.map(item => {
					return {
						'Номер': item?.request?.number,
						'VIN': item?.request?.vin,
						'Марка': item?.request?.brand?.name,
						'Модель': item?.request?.model?.name,
						'Рік випуску': item?.request?.yearProd,
						'Тип приводу': item?.request?.driver?.name,
						"Об'єм двигуна, л": item?.request?.engineVolume,
						'Тип палива': item?.request?.fuel?.name,
						'Коробка передач': item?.request?.gearbox?.name,
						'Колір': item?.request?.color?.name,
						'Показник одометра': item?.request?.odometer,
						//'Оціночна вартість (мінімальна), UAH': item.minPriceUAH,
						//'Оціночна вартість (мінімальна), USD': item.minPriceUAH,
						'Середня ціна, UAH': item.avgPriceUAH,
						'Середня ціна, USD': item.avgPriceUSD,
						//'Оціночна вартість (максимальна), UAH': item.maxPriceUAH,
						//'Оціночна вартість (максимальна), USD': item.maxPriceUSD,

					};
				});

				const worksheet2 = XLSX.utils.json_to_sheet(jsa);

				//console.log(this.$options.name, 'onExcelEstimate', 'jsa', jsa)

				XLSX.utils.book_append_sheet(workbook, worksheet, 'Оцінка');
				XLSX.utils.book_append_sheet(workbook, worksheet2, 'Транспортні засоби');
				XLSX.writeFileXLSX(workbook, filename);
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		calculateTotalUAH() {
			const totalPrice = this.item.objects.reduce((accumulator, currentValue) => accumulator + currentValue.avgPriceUAH, 0);
			return totalPrice
		},
		calculateTotalUSD() {
			const totalPrice = this.item.objects.reduce((accumulator, currentValue) => accumulator + currentValue.avgPriceUSD, 0);
			return totalPrice
		},

		

		/* identification(item) {
			if(item) {
				axios.get(`/vehicle/identification/${item.id}`).then(response => {
					console.log(this.$options.name, 'identification','response.data', response.data)
					//const index = that.estimates.indexOf(item)
					//that.estimates.splice(index, 1);
				}, error => {
					console.log(error)
				}).finally(() => { this.loading = false });
			}
		}, */
	},
}
</script>